import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import moment from 'moment';
import Constants from 'style/constants';
import ScanSearchIcon from 'shared/components/icons/scan-search-icon';

import { useSystemsContextProvider } from 'features/systems/context/systems-provider';
import { SystemStatus } from 'features/systems/domain/models/system-status';
import { useIS32ContextProvider } from 'features/systems/IS32/context/IS32-provider';
import styles from 'features/systems/IS32/views/IS32-scan-configuration.module.scss';

const IS32ScanConfiguration = (): React.JSX.Element => {
  const { t } = useTranslation('IS32');

  const {
    systemsDetailsHook: { selectedSystem },
  } = useSystemsContextProvider();

  const { startScan, startScanIsLoading } = useIS32ContextProvider();

  const isSystemOffline = selectedSystem?.status === SystemStatus.offline;

  return (
    <div className={styles.scanContainer}>
      <Typography variant="h5">{t('startScanLabel')}</Typography>
      <Button
        startIcon={<ScanSearchIcon color={Constants.Colors.primary} />}
        variant="outlined"
        onClick={() => startScan(selectedSystem?.id ?? '')}
        disabled={startScanIsLoading || isSystemOffline}
      >
        {t('startScanButtonLabel')}
      </Button>
      {selectedSystem?.lastSystemEvent && (
        <Typography variant="subtitle1">
          {t('startScanSubInformation', {
            scanDatetime: moment(selectedSystem?.lastSystemEvent?.lastStatusChangeOn).format('DD-MM-YYYY HH:mm').toString(),
          })}
        </Typography>
      )}
    </div>
  );
};

export default IS32ScanConfiguration;
